import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { isAndroid } from '@helpers';
import TouchableElement from '@components/common/touchableElement';
import { SmallLoading } from '@components/loading';

import { font } from '@styles/fonts';
import Svg from '@styles/icons/svg';

import { modalFieldBg, SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

import { SelectableListProps } from '@components/devInfo/environment/types';

const SelectableList: React.FC<SelectableListProps> = ({ items, selectedValue, onSelect, loading, C, renderTrailingContent }) => {
  return (
    <>
      {items.map((item, index) => {
        const firstIndex = index === 0;
        const lastIndex = index === items.length - 1;
        return (
          <View key={item.name} style={{ width: '100%' }}>
            <TouchableElement onPress={() => onSelect(item)}>
              {({ pressHoverColor, boxStyle }) => (
                <View
                  style={[
                    boxStyle,
                    {
                      marginTop: isAndroid ? StyleSheet.hairlineWidth : 0,
                      paddingLeft: scale(15),
                      backgroundColor: C(pressHoverColor(modalFieldBg)),
                      zIndex: items.length - index,
                    },
                    firstIndex && {
                      borderTopLeftRadius: scale(SCREEN_BORDER_RADIUS),
                      borderTopRightRadius: scale(SCREEN_BORDER_RADIUS),
                    },
                    lastIndex && {
                      borderBottomLeftRadius: scale(SCREEN_BORDER_RADIUS),
                      borderBottomRightRadius: scale(SCREEN_BORDER_RADIUS),
                    },
                  ]}
                >
                  <View style={{ height: scale(46), width: '100%', flexDirection: 'row' }}>
                    <View
                      style={{ justifyContent: 'center', marginRight: scale(6.5), width: scale(19), opacity: item.value === selectedValue ? 1 : 0 }}
                    >
                      {loading ? <SmallLoading /> : <Svg icon="check" color="Link/Light/Primary" width={scale(19)} height={scale(19)} />}
                    </View>
                    <View
                      style={[
                        !lastIndex && {
                          borderBottomColor: C('Hairline / Light / No trans'),
                          borderBottomWidth: StyleSheet.hairlineWidth,
                        },
                        { flex: 1, alignItems: 'center', flexDirection: 'row', justifyContent: 'space-between' },
                      ]}
                    >
                      <Text style={[font['Body'], { color: C('Label/Light/Primary') }]}>{i18n.t(item.name)}</Text>
                      {renderTrailingContent && renderTrailingContent(item)}
                    </View>
                  </View>
                </View>
              )}
            </TouchableElement>
          </View>
        );
      })}
    </>
  );
};

export default SelectableList;
